import React from 'react'

export class LdsSpinner extends React.Component {
    render(){
        return <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    }
}


export class FileUploadRing extends React.Component {
    render() {
        return <div className="file-upload-ring"><div></div><div></div><div></div><div></div></div>
    }
}
